<template>
	<v-card flat>
		<v-card-text>
			<brace
				style="height:90vh; width:100vw;"
				:mode="'text'"
				@code-change="onEditorCodeChange"
				@setHandler="
					h => {
						editorHandler = h;
					}
				"
			/>
		</v-card-text>
	</v-card>
</template>

<script>
import constants from '@/api';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import { TextEncoder } from 'util';
export default {
	components: {},
	data() {
		return {
			editorHandler: false,
			displayText: false,
		};
	},
	created() {},
	methods: {
		// ...mapMutations("fileExtraction", ["closeFileMetaDialog"]),
		...mapActions('fileExtraction', ['getFileJSON']),
		onEditorCodeChange(code) {
			this.editorCode = code;
			// console.log(code);
		},
	},
	computed: {
		// ...mapGetters("fileExtraction", ["selectedFile"])
	},
	mounted() {
		var req = new XMLHttpRequest();
		req.open(
			'GET',
			constants.UTILITY_OG_FILE +
				'?uuid=' +
				this.selectedFile.filename.split('.')[0],
			true
		);
		req.responseType = 'arraybuffer';
		req.setRequestHeader('Authorization', this.$store.getters.authToken);

		req.onload = e => {
			this.displayText = new TextDecoder().decode(new Uint8Array(req.response));
			this.editorHandler.setValue(this.displayText);
		};

		req.send();
	},
	props: ['selectedFile'],
};
</script>

<style lang="scss" scoped>
.v-card__text {
	padding: 0px;
}
</style>
